import { render, staticRenderFns } from "./ComplaintQualityList.vue?vue&type=template&id=4800b968&scoped=true"
import script from "./ComplaintQualityList.vue?vue&type=script&lang=js"
export * from "./ComplaintQualityList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintQualityList.vue?vue&type=style&index=0&id=4800b968&prod&lang=scss"
import style1 from "./ComplaintQualityList.vue?vue&type=style&index=1&id=4800b968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800b968",
  null
  
)

export default component.exports